import { parseAsBoolean, useQueryState } from '@vrplatform/query-params';

export function usePlaidSandbox() {
  const [plaidSandbox, setPlaidSandbox] = useQueryState(
    'plaid-sandbox',
    parseAsBoolean
  );

  return {
    plaidSandbox,
    setPlaidSandbox,
  };
}
